import { render, staticRenderFns } from "./WebPartFormShopWithProductDesigner.vue?vue&type=template&id=f823ed54&scoped=true&"
import script from "./WebPartFormShopWithProductDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopWithProductDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormShopWithProductDesigner.vue?vue&type=style&index=0&id=f823ed54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f823ed54",
  null
  
)

export default component.exports